<template>
  <div id="bar" v-if="loaded">
    <Bar :data="datacollection" :options="options"></Bar>
  </div>
</template>

<script>
import { Bar } from 'vue-chartjs'
import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale } from 'chart.js'
ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)

  export default {
    props: ["data"],
    components: { Bar },
    data () {
      return {
        loaded: false,
        datacollection: null,
         options: {
          responsive: true, 
          stacked: true,
            legend:{
                position:'left',
                display:false

            },
             tooltips: {
                mode: 'nearest',
                intersect: false,
              },
             
            
        }
      }
    },
    mounted () {
      this.fillData()
    }, 
    methods: {
      fillData () {

        if (!this.isNull(this.data)) 
        {
          this.datacollection = {
            labels: this.data.labels.map((row) => { return row}),
             datasets: []
          }
          
            let datasets = [];
            let data = [];
            let backgroundColor = [];
            let label = [];

            
              datasets.push({
                    fill: true,
      
                    data: [],
              
                })
            
              for (let i in this.data.labels)
            {
              data.push(this.data.datasets[0].data[i])
              backgroundColor.push(this.color_array[i],)
              label.push(this.data.labels[i].label)
            }

            
            this.datacollection.datasets = datasets;
            this.datacollection.datasets[0].data = data;
            this.datacollection.datasets[0].backgroundColor = backgroundColor;
            
            this.loaded = true;
        }

      },
    }
  }
</script>

<style>
/* #bar{height: 300px;} */
  .small {
    max-width: 600px;
    margin:  150px auto;
  }
</style>
